// Enum-Values corrospons the index of the expansion-panel in checkoutNextStep
export const Payment = {
  PayPal: 0,
  Credit: 1,
  getKey
}

// get the enum key by value
function getKey(enumValue) {
  return Object.keys(Payment).find(key => Payment[key] === enumValue)
}
